import { useEffect, useState } from "react";
import styled from "styled-components";
import thumb1 from "../assets/images/social-impact-award.webp";
import WhoCanApply from "./WhoCanApply";

const SocialImpactAwards = () => {

    const [showForm, setShowForm] = useState(false);
  
useEffect(() => {
  if (showForm) {
    const loadForm = () => {
      if (window.hbspt) {
        const container = document.getElementById("about-hubspot-form");
        if (container) {
          container.innerHTML = "";

          window.hbspt.forms.create({
            region: "na2",
            portalId: "46890133",
            formId: "425f93b6-55f2-4ad3-9471-590c5cccc06f",
            target: "#about-hubspot-form"
          });
        }
      }
    };

    if (window.hbspt) {
      loadForm();
    } else {
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/embed/v2.js";
      script.async = true;
      script.onload = loadForm;
      document.body.appendChild(script);
    }
  }
}, [showForm]);

  return (
    <>
    <Section id='social-impact-awards'>
      <MainHeading>
        IIT Madras Social Impact Awards 2026
      </MainHeading>
      <Description>
        <Text>
            As part of the <b>IIT Madras Technology Summit & Awards 2026</b>, and aligned with the theme{" "}
            <Highlight>“From IITM. For Bharat. Building Together.”</Highlight>, the Social Impact Awards
            celebrate organizations that harness technology to create meaningful, measurable, and inclusive
            impact across India.
          </Text>
          </Description>
      <Container>

<Right>
          <Thumbnail>
            <img src={thumb1} alt="awards" />
          </Thumbnail>
        </Right>

        <Left>
          

          <SubHeading>The Awards recognize:</SubHeading>

          <List>
            <ListItem>
              Organizations that have enabled technology-driven solutions addressing critical societal
              challenges — translating innovation into scalable, on-ground impact across diverse geographies.
            </ListItem>

            <ListItem>
              Organizations that leverage CSR and strategic partnerships to strengthen last-mile access,
              improve outcomes, and advance inclusive growth through technology.
            </ListItem>
          </List>

            <WhoCanApply/>

            {/* <Button onClick={() => setShowForm(true)}>
              Nominate for Social Impact Awards
            </Button> */}

        </Left>

      </Container>
    </Section>
    {/* HUBSPOT FORM MODAL */}
{showForm && (
  <FormModalOverlay onClick={() => setShowForm(false)}>
    <FormModalContent onClick={(e) => e.stopPropagation()}>
      <FormCloseBtn onClick={() => setShowForm(false)}>✕</FormCloseBtn>
      <div id="about-hubspot-form"></div>
    </FormModalContent>
  </FormModalOverlay>
)}
</>
  );
};

export default SocialImpactAwards;
const Section = styled.section`
  scroll-margin-top: 100px;
  padding: 40px 20px;
  background: #f9f9f9;

  @media (max-width: 768px) {
  padding: 6px 6px;
  scroll-margin-top: 100px;
}
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const Left = styled.div`
  order: 2;

  @media (max-width: 900px) {
    order: 2;
    text-align: center;
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  order: 1;
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 2px;

  @media (max-width: 768px) {
    font-size: 13px;
    text-align: center;
  }
`;

const Button = styled.button`
  padding: 14px 34px;
  border: none;
  background: linear-gradient(90deg, #d6a54f, #bd8a32);
  color: white;
  font-weight: 600;
  border-radius: 40px;
  cursor: pointer;
  transition: 0.3s;
  font-family: inherit;
  font-size: inherit;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`;

const Thumbnail = styled.div`
  width: 100%;
  max-width: 500px;
  border-radius: 14px;
  overflow: hidden;  
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);

  img {
    padding: 20px;
    width: 100%;
    display: block;
    transition: 0.4s;
    //background: #791e1b;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const Highlight = styled.span`
  font-weight: 600;
  color: #d6a54f;
  font-style: italic;
`;

const SubHeading = styled.h3`
  font-size: 30px;
  color: #791e1b;

  @media (max-width: 768px) {
    text-align: center;
    font-size: 16px;
  }
`;

const List = styled.ul`
  padding-left: 0;
  list-style:none;
`;

const ListItem = styled.li`
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #444;
  line-height: 1.6;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 8px;
    height: 8px;
    background: #d6a54f;
    border-radius: 50%;
  }

  @media (max-width: 768px) {
    text-align: left;
    font-size: 12px;
    margin-bottom: 2px;
  }
`;

const Description = styled.div`
    padding: 20px;
    max-width: 1200px;
    text-align: center;
    margin: 0 auto;

    @media (max-width: 768px) {
    padding: 2px;
  }
`;

const FormModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647;
  isolation: isolate; 
`;

const FormModalContent = styled.div`
  background: #ffffff;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 14px;
  padding: 40px 30px;
  position: relative;
`;

const FormCloseBtn = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #d6a54f;
  color: white;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background: #bd8a32;
  }
`;